import styled from "styled-components";

const CategoriesStyles = {
    CategoriesMainContainer: styled.div`
        display: flex;
        flex-flow: column;
        align-items: center;
    `,

    CategoriesContainer: styled.div`
        width: max-content;
        margin-top: 30px;
        height: 35px;
        /* width: 70%; */
        /* border-width: 2px;
        border-style: solid;
        border-image: linear-gradient(to right, black, yellow) 0 0 100% 0; */
        background-image: linear-gradient(to right, black, yellow);
        /* display: flex; */
        display: ${(props) => (props.mobile ? "none" : "flex")};
        justify-content: space-between;
        gap: 1px;
        align-items: flex-start;
        margin-bottom: 40px;
        @media (max-width: 1030px) {
            display: ${(props) => (props.mobile ? "flex" : "none")};
        }
    `,

    CategoriesBgBox: styled.div`
        /* height: 98%; */
        height: 34px;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        cursor: pointer;
    `,

    CategoriesBox: styled.div`
        height: 30px;
        padding: 0px 2vw;
    `,

    CategoryText: styled.div`
        position: relative;
        text-transform: uppercase;
        font-size: 1.6rem;
        bottom: 15px;
        font-weight: ${(props) =>
            props.currentCategory === props.category ? "bold" : "normal"};
        /* color: ${(props) =>
            props.currentCategory === props.category ? "#e1d816" : "black"}; */
        /* text-decoration: ${(props) =>
            props.currentCategory === props.category ? "underline" : "none"};
        text-underline-offset: 6px; */
    `,
};

export default CategoriesStyles;
